export const INCENTIVE_PAYMENT_TYPES = {
    RULE_BASED: 'RULE_BASED',
    FIXED: 'FIXED',
};

export const RULE_TIERS_PAYMENT_TYPES = {
    FIXED_RATE: 'FIXED_RATE',
    PAY_RATE_PERCENTAGE: 'PAY_RATE_PERCENTAGE'
}

export const RULES_STATUSES = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
}

export const CENTS_PER_DOLLAR = 100;